import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithStreamByRequestUid,
} from 'widgets/WidgetRegistry';
import State from 'store/State';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { OrderColumns } from 'communication/types/order/Order';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { LiquidityStreamRequest } from 'widgets/liquiditySummary/api/LiquiditySummaryStreamRequest';
import { liquidityStreamConfig } from 'widgets/liquiditySummary/store/data/stream-config';
import { PredictedVolumeCapsule } from './components/PredictedVolumeCapsule';
import { predictedRemainingVolumeCapsuleDescription } from './description/predictedRemainingVolumeCapsuleDescription';
import {
    initialPredictedRemainingVolumeCapsuleConfigState,
    PredictedVolumeCapsuleConfigState,
} from 'widgets/liquiditySummary/predictedVolumeCapsule/state/config/PredictedVolumeCapsuleConfigState';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';
import { buildPredictedVolumeCapsuleConfigSlice } from 'widgets/liquiditySummary/predictedVolumeCapsule/state/config/configslice';
import { WidgetType } from 'widgets/WidgetType';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import React from 'react';
import { PredictedVolumeCapsuleMyPortfolioCapsuleContent } from 'widgets/liquiditySummary/predictedVolumeCapsule/components/PredictedVolumeCapsuleMyPortfolioCapsuleContent';

const { useStreamedDataMessages } = liquidityStreamedDataSelectors;

const { initialConfigState } = buildPredictedVolumeCapsuleConfigSlice(
    WidgetType.PREDICTED_VOLUME_CAPSULE
);
const useMessagesInMyPortfolioCapsules = (
    symbol: string,
    _symbology: SymbologyValues,
    qty?: number
) => useStreamedDataMessages(symbol, initialConfigState, qty);

export const predictedRemainingVolumeCapsuleWidgetStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<PredictedVolumeCapsuleConfigState> &
    WidgetStrategyWithConfig<PredictedVolumeCapsuleConfigState> &
    WidgetStrategyWithStreamByRequestUid<LiquidityStreamRequest> = {
    title: 'Predicted Remaining Volume',
    supportedHosts: ['tile'],
    reactComponentType: PredictedVolumeCapsule,
    getRequiredOrderColumns,
    categories: [WidgetCategory.VOLUME_CAPSULES],
    description: predictedRemainingVolumeCapsuleDescription,
    managedStreamConfig: liquidityStreamConfig,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.SingleSymbolQuantity,
    initialConfigState: initialPredictedRemainingVolumeCapsuleConfigState,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    myPortfolioCapsuleContentReactComponentType:
        PredictedVolumeCapsuleMyPortfolioCapsuleContent,
    renderSettingsBody: () => <></>,
    useMessagesInMyPortfolioCapsules,
};

function getRequiredOrderColumns(
    _state: State,
    _widgetId: string,
    _symbology: SymbologyValues
): OrderColumns {
    return ['rem'];
}
